if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"room_client","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(default\-webpack_sharing_consume_default_angular_core_angular_core|vendor|webpack_sharing_consume_default_angular_animations_browser_angular_animations_browser)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}